module.exports = __webpack_public_path__ + "static/cauzl_logo-d9972d6f3bcddf6f65da5b3a22869677.svg";